"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
exports.default = {
    addToCart: 'Add to Cart',
    auction: 'Live Auction',
    shipping: 'Shipping',
    freeShipping: 'Free Shipping',
    acceptsOffers: 'Accepts Offers',
    localPickupOnly: 'Local Pickup Only',
    plusShipping: '+ Shipping',
    collapsingFacets: {
        collapse: 'Collapse',
        showMore: 'Show More',
    },
    collapsingList: {
        collapse: 'Collapse',
        showMore: 'Show More',
    },
    free: 'Free',
    ribbonView: {
        bidNow: 'Bid Now',
    },
    pills: {
        filteredBy: 'Filtered by',
        item_region: 'In %{region}',
        ships_to: 'Ships to %{region}',
    },
    filters: {
        closePanel: 'Done',
        filterResults: 'Filter Results',
    },
    formGroup: {
        optional: 'Optional',
        recommended: 'Recommended',
        required: 'Required',
    },
    next: 'Next',
    nextImage: 'Next image',
    previous: 'Previous',
    previousImage: 'Previous image',
    lpConditionDisplay: {
        condition: {
            new: 'New',
            used: 'Used',
            mint: 'Mint',
            nearMint: 'Near Mint',
            veryGoodPlus: 'Very Good Plus',
            veryGood: 'Very Good',
            goodPlus: 'Good Plus',
            good: 'Good',
            fair: 'Fair',
            poor: 'Poor',
            noCover: 'No Cover',
            generic: 'Generic Cover',
        },
        conditionShort: {
            mint: 'M',
            nearMint: 'NM',
            veryGoodPlus: 'VG+',
            veryGood: 'VG',
            goodPlus: 'G+',
            good: 'G',
            fair: 'F',
            poor: 'P',
            noCover: 'NC',
            generic: 'X',
        },
        mediaCondition: {
            mint: 'Mint: the media is flawless',
            nearMint: 'Near Mint: the media is pristine but unsealed',
            veryGoodPlus: 'Very Good Plus: the media is very lightly worn but playback is unaffected',
            veryGood: 'Very Good: the media has marks that are visible but playback is unaffected',
            goodPlus: 'Good Plus: the media has some marks/noise',
            good: 'Good: the media has noticeable marks/noise but plays without skipping',
            fair: 'Fair: the media is notably damaged',
            poor: 'Poor: the media is severely damaged',
        },
        sleeveCondition: {
            mint: 'Mint: the sleeve is pristine',
            nearMint: 'Near Mint: the sleeve is almost like new',
            veryGoodPlus: 'Very Good Plus: the sleeve is very mildly worn',
            veryGood: 'Very Good: the sleeve is slightly worn',
            goodPlus: 'Good Plus: the sleeve is noticeably worn',
            good: 'Good: the sleeve is very worn',
            fair: 'Fair: the sleeve is heavily worn',
            poor: 'Poor: the sleeve is falling apart',
            noCover: 'No Cover: media only, no packaging',
            generic: 'Generic: standard blank sleeve',
        },
    },
    sanitizedRender: {
        collapse: 'collapse',
        expand: 'read more',
        expandEllipsis: 'read more…'
    },
    selectFormGroup: {
        selectOne: 'Select one…',
    },
    shopBadges: {
        preferredSeller: 'Preferred Seller',
        preferredSellerDescription: 'This seller provides outstanding service',
        quickResponder: 'Quick Responder',
        quickResponderDescription: 'This seller responds quickly to messages',
        quickShipper: 'Quick Shipper',
        quickShipperDescription: 'On average, this seller ships within 24 hours',
    },
    watchBadge: {
        watch: 'Watch',
        unwatch: 'Watching',
        move: 'Move to Watch List',
        watchers: {
            one: '{{count}} Watcher',
            other: '{{count}} Watchers',
        },
        benefits: {
            signUp: 'Join Reverb to Watch This Listing',
            priceDrop: 'We\'ll notify you if the price drops',
            offers: 'We\'ll notift you if anyone else makes an offer',
        }
    },
    currency: {
        display: {
            format: '%u%n',
            symbol: '$',
            separator: '.',
            delimiter: ',',
            precision: '2',
        },
        unsupportedCurrencyConversion: 'Conversion between from currency {{fromCurrency}} and to currency {{toCurrency}} is not supported',
    },
    auctionForm: {
        bidNow: 'Bid Now',
        ended: 'Ended',
        increaseBid: 'Increase Bid',
        inputPlaceholder: 'Bid amount ...',
        viewAuction: 'View Auction',
        outbid: "You've been outbid",
    },
    auctionStatus: {
        LOSING: "You're being outbid!",
        WINNING: "You're winning!",
        WON: "You've won!",
    },
    auctionHelpers: {
        bidSummary: {
            amount: 'Bid at least {{amount}}',
            currentBid: 'Your current max bid is {{display}}',
        },
        errors: {
            bidMustBeHigherThanMinimum: 'Your bid must be higher than the current minimum bid of {{formattedBidMinimum}}.',
            bidMustBeHigherThanYourCurrentMax: 'Your new bid must be higher than your current max bid of {{currentMax}}.',
        },
        priceSummary: {
            startingBid: 'Starting Bid',
            currentBid: 'Current Bid',
        },
        timeSummary: {
            endsAt: 'Ends {{date}}',
            endedAt: 'Auction ended {{date}}',
            startsAt: 'Bidding begins {{date}}',
        },
    },
    modalDialog: {
        goBack: 'go back',
        save: 'Save Changes',
        delete: 'Delete',
        wait: 'Please wait...',
    },
    addFollowToFeed: {
        addToGearAlerts: 'Also add this to my Daily Feed email',
        removeFromGearAlerts: 'Remove from my Daily Feed email',
        followSearch: 'View all matching listings',
        remove: {
            removeFromFeed: 'Remove from feed',
            areYouSure: 'Are you sure?',
            confirm: 'Yes',
            cancel: 'No',
            removeHint: "Matching items will be removed from your feed and we won't add any new ones.",
        },
    },
    bumpsView: {
        header: 'Reverb Bump',
    },
    regionFilterOptions: {
        loadPlaceholder: 'Change',
    },
    searchControls: {
        used: 'Used',
        new: 'Brand New',
    },
    modal: {
        backAction: 'Go back',
    },
    offers: {
        action: {
            create: 'Make an Offer',
            counter: 'Counter',
            accept: 'Accept',
            reject: 'Decline',
        },
        backAction: 'Cancel',
        originalPrice: 'List price: {{price}}',
        submitOfferButton: 'Submit Offer',
        submitOfferButtonWithAmount: 'Submit Offer for {{offerTotal}}',
        offerTipLowball: 'Many sellers will reject an offer that low.',
        offerTipHighball: "You're offering more than the asking price. Is that correct?",
        percentOff: '{{percent}}% Off',
        recommendedOffers: 'Recommended offers:',
        nudgeHeaderLowball: 'Buying Tip',
        nudgeHeaderHighball: 'Heads Up!',
        nudgeDisclaimerLowball: 'Based on past transaction data, a higher offer has a better chance of being accepted.',
        nudgeDisclaimerHighball: 'Your offer is higher than the listing price. Are you sure you want to offer {{tagOpen}}{{amount}}{{tagClose}}?',
        currencyApproximation: 'Your offer: {{offerAmount}} + {{shippingPrice}} Shipping',
        currencyApproximationUnknownShipping: 'Your offer: {{offerAmount}} + Shipping',
        sellerCurrencyWarning: "This seller receives offers in {{shopCurrency}}. What you'll pay in {{userCurrency}} may vary slightly based on exchange rates.",
        valueMayVary: 'The equivalent value in {{userCurrency}} may vary',
        offerQuantity: 'Quantity',
        saleNotice: 'Sale discounts do not apply to offers',
        freeTwoDayShippingNotice: 'Free 2-Day shipping does not apply to offers',
        combinedSaleShippingNotice: 'Sale discounts and free 2-Day shipping do not apply to offers',
        timeline: '{{shopName}} has 24 hours to reply.',
        salesTaxMayBeApplied: 'Sales tax may be applied during checkout. See %{linkOpen}Shop Policies%{linkClose} for details.',
        shippingPrice: '+ {{shippingPrice}} Shipping',
        label: {
            counterPrice: 'Your Counter Offer',
            initialPrice: 'Your Best Offer',
            shipping: 'Shipping Price',
        },
        sellerMessageLabel: 'Message to Buyer',
        buyerMessageLabel: 'Message to Seller',
        terms: 'I agree to pay if my offer is accepted',
        location: {
            shippingTo: 'Shipping to {{regionName}}, {{postalCode}}',
            change: 'Change',
            shippingRegionLabel: 'Shipping Region',
            postalCodeLabel: 'Shipping Postal/ZIP Code',
            localPickupDetails: 'Local Pickup in {{location}}',
            noShippingCostSet: 'The seller has not set a shipping cost for this region',
        },
        cancel: 'Cancel',
        error: "We're sorry, something went wrong. Please try again.",
        seller: 'seller',
        buyer: 'buyer',
        initialSubmissionSuccess: "Your offer of {{amount}} has been submitted. You'll hear from the {{otherParty}} soon.",
        sidebar: {
            condition: 'Condition',
            askingPrice: 'Asking Price',
            shipping: 'Shipping',
            viewListing: 'View Listing',
            shopDisplayLocation: 'Ships From',
            sellerCost: 'Your Price',
            watches: 'Watches'
        },
        benefits: {
            title: 'Sign Up to Make an Offer',
            saveMoney: 'Save 10-15% on average',
            quickResponse: 'Most sellers respond within 4 hours',
        },
        autoOffers: 'Auto Offers'
    },
    subRegions: {
        US_CON: 'Continental U.S.',
        US_AK: 'Alaska',
        US_HI: 'Hawaii',
        US_PR: 'Puerto Rico',
        US_OTHER: 'Other U.S. Territories',
    },
    signupForm: {
        signupHeader: 'Create a Reverb Account',
        signinHeader: 'Log in to Reverb',
        firstNameLabel: 'First name',
        lastNameLabel: 'Last name',
        emailLabel: 'Email',
        emailConfirmLabel: 'Email Confirmation',
        emailMatchError: 'Emails must match',
        passwordLabel: 'Password',
        passwordTip: '(at least {{minLength}} characters)',
        newsletterLabel: 'Get the latest news, deals, and promotions via email',
        acceptTermsLabel: 'By clicking Sign Up, I expressly agree to accept Reverb’s {{termsLinkOpen}}Terms of Use{{linkClose}} and {{privacyLinkOpen}}Privacy Policy{{linkClose}',
        gdprAcceptTermsLabel: 'By clicking Sign Up, I expressly agree to accept Reverb’s {{termsLinkOpen}}Terms of Use{{linkClose}} and {{privacyLinkOpen}}Privacy Policy{{linkClose}}, including the processing of my personal data for access to the Reverb Marketplace and for Reverb ads.',
        gdprHowReverbUsesData: 'How Reverb Uses Data',
        gdprReverbProcessesData: 'Reverb processes your data to provide you with access to its marketplace as a buyer, seller, or both, or as a developer utilizing the API or creating Applications. To learn about changing your data processing settings, visit our {{gdprPolicyLinkOpen}}policy page{{linkClose}}.',
        signUp: 'Sign Up',
        logIn: 'Log In',
        facebookSignup: 'Sign Up with Facebook',
        facebookSignin: 'Log In with Facebook',
        rememberMe: 'Stay signed in',
        forgotPassword: 'Forgot your Password?',
        passwordReset: 'Reset it',
        alreadyHaveAccount: 'Already have an account?',
        dontHaveAccount: "Don't have an account yet?",
    },
    dynamicPage: {
        pageEditLink: 'Edit This Page',
        footerByline: 'Editorial content by {{author}}',
    },
    dynamicPageHead: {
        searchPlaceholder: 'Search in this set',
        actionText: 'View All Listings',
    },
    notFound: {
        pageTitle: 'Not Found',
        title: "Sorry, this page isn't available.",
        description: 'The link you followed may be broken or the page may have been deleted.',
    },
    propertySwitcher: {
        core: 'Reverb',
        lp: 'Reverb LP',
    },
    errorDisplay: {
        header: 'Oops',
        message: 'Something went wrong. Please try again.',
    },
    cspPgCard: {
        estimatedValue: 'Price Guide Estimated Value',
        usedFrom: '{{count}} used from {{price}}',
        newFrom: '{{count}} new from {{price}}',
        comparePrices: 'Compare Prices',
    },
    quantitySelector: {
        inStock: {
            zero: 'Out of stock',
            one: 'Only 1 left - act fast!',
            other: '{{count}} in stock',
        }
    },
    nudgeManager: {
        negotiate: 'This seller is open to offers',
        saveMoney: 'Save 10-15% on average',
        watchNudge: 'Watch this listing to get price drop alerts',
    },
    specList: {
        condition: 'Condition',
        conditionNew: '{{name}} (New)',
        conditionUsed: '{{name}} (Used)',
        learnMore: 'learn more',
        conditions: {
            'brand-new': 'Brand New items are sold by an authorized dealer or original builder and include all original packaging.',
            'b-stock': 'B-Stock items are sold by an authorized dealer or original builder, but have been opened, blemished, or used in some manner.',
            'like-new': 'Like New items are in essentially new original condition but have been opened or played.',
            mint: 'Mint items are in essentially new original condition but have been opened or played.',
            'mint-with-inventory': 'Mint items are in essentially new original condition but have been opened or played.',
            excellent: 'Excellent items are almost entirely free from blemishes and other visual defects and have been played or used with the utmost care.',
            'very-good': 'Very Good items may show a few slight marks or scratches but are fully functional and in overall great shape.',
            good: 'Good condition items function properly but may exhibit some wear and tear.',
            fair: 'Fair condition gear should function but will show noticeable cosmetic damage or other issues.',
            poor: 'Poor condition gear may not work properly but can still perform most functions.',
            'non-functioning': 'Non-functioning items do not work as they should. All known issues should be described in the listing description.',
        },
    },
};
//# sourceMappingURL=en.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/dist/en.js
// module id = eZq1
// module chunks = 0 2 20